"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extension = void 0;
const path_1 = require("path");
exports.extension = (path) => path_1.extname(path).substr(1) || undefined;
//# sourceMappingURL=extension.js.map